// SPDX-License-Identifier: Apache-2.0

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ReactElement } from "react";

export interface InfoProps {
  show: boolean;
  toggleShow: () => void;
  title?: string;
  content?: ReactElement;
}

/**
 * Returns a Modal with the given title and content.
 * @param props -
 * @constructor
 */
export default function InfoModal(props: InfoProps) {
  return (
    <Modal
      className="infomodal"
      aria-labelledby="contained-modal-title-vcenter"
      show={props.show}
      onHide={props.toggleShow}
      centered
      backdrop={"static"}
    >
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{props.content || <></>}</Modal.Body>
      <Modal.Footer>
        <Button
          className={"next-button"}
          variant={"primary"}
          onClick={() => {
            props.toggleShow();
          }}
        >
          close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
